import React, { memo, useMemo } from 'react';
import { FaExclamation } from 'react-icons/fa';
import { formatTime } from '../../../../utils/formatter';
import CheckMark from '../../../shared/status/CheckMark';
import Row from '../../../shared/table/Row';
import SelectableRow from '../../../shared/table/SelectableRow';
import Table from '../../../shared/table/Table';

const SplitTaskTable = ({ visitTasks, selectedTasks, allSelected, loading, onVisitTaskSelect, onSelectAll }) => {
  const tableRows = useMemo(
    () =>
      visitTasks.map((visitTask, i) => {
        const isSelected = selectedTasks.includes(visitTask.id);
        return (
          <SelectableRow key={i} onClick={() => onVisitTaskSelect(visitTask)}>
            <Row>
              <CheckMark isChecked={isSelected} />
            </Row>
            <Row>
              <div className="flex gap-1 items-center">
                {visitTask.isCritical && <FaExclamation size={14} className="text-contrast1" />}
                {visitTask.task.name}
              </div>
            </Row>
            <Row children={formatTime(visitTask.hours)} />
          </SelectableRow>
        );
      }),
    [visitTasks, selectedTasks, onVisitTaskSelect],
  );

  return <Table columns={columns({ onSelectAll, allSelected })} data={tableRows} />;
};

function columns({ onSelectAll, allSelected }) {
  return [
    { object: <CheckMark isChecked={allSelected} onClick={onSelectAll} />, className: 'w-[5%]' },
    { name: 'Назва', className: 'w-[85%]' },
    { name: 'н/г', className: 'w-[10%]' },
  ];
}

export default memo(SplitTaskTable);
